// eslint-disable-next-line import/no-cycle
// import REPSEmojiTypeRenderer from '../../components/EventSearch/REPSEmojiTypeProvider';

const ZERO = 0;

const windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || ZERO);

export const columns = [
  { name: 'event_id', title: 'ID', rendererFunction: null, sortable: true },
  { name: 'emoji', title: String.fromCodePoint(0x1f525), rendererFunction: () => {}, sortable: false },
  { name: 'event_name', title: 'Name', rendererFunction: params => params.value, sortable: true },
  { name: 'event_genre', title: 'Genre', rendererFunction: null, sortable: true },
  { name: 'performer', title: 'Performer', rendererFunction: null, sortable: true },
  { name: 'event_links', title: 'Links', rendererFunction: params => params.value, sortable: false },
  { name: 'event_date', title: 'Date', rendererFunction: null, sortable: true },
  { name: 'day_of_week', title: 'Day Of Week', rendererFunction: null, sortable: true },
  { name: 'days_until_event', title: 'Days Until Event', rendererFunction: null, sortable: true },
  { name: 'onsale_date', title: 'Onsale Date', rendererFunction: params => params.value, sortable: true },
  { name: 'checked_time', title: 'Checked Time', rendererFunction: null, sortable: true },
  { name: 'days_since_last_checked', title: 'Days Since Last Checked', rendererFunction: null, sortable: true },
  { name: 'venue_name', title: 'Venue Name', rendererFunction: null, sortable: true },
  { name: 'venue_city', title: 'Venue City', rendererFunction: null, sortable: true },
  { name: 'venue_state', title: 'Venue State', rendererFunction: null, sortable: false },
  { name: 'venue_type', title: 'Venue Type', rendererFunction: null, sortable: true },
  { name: 'venue_capacity', title: 'Max Capacity', rendererFunction: null, sortable: true },
  { name: 'primary_event_capacity', title: 'Event Capacity', rendererFunction: null, sortable: true },
  { name: 'primary_qnt_3day', title: '3 Day MA', rendererFunction: null, sortable: true },
  { name: 'primary_qnt_7day', title: '7 Day MA', rendererFunction: null, sortable: true },
  { name: 'primary_qnt_30day', title: '30 Day MA', rendererFunction: null, sortable: true },
  { name: 'one_day_primary_pace', title: '1 Day Primary Pace', rendererFunction: null, sortable: false },
  { name: 'three_day_primary_pace', title: '3 Day Primary Pace', rendererFunction: null, sortable: false },
  { name: 'seven_day_primary_pace', title: '7 Day Primary Pace', rendererFunction: null, sortable: false },
  { name: 'thirty_day_primary_pace', title: '30 Day Primary Pace', rendererFunction: null, sortable: false },
  { name: 'primary_tix_av', title: 'Primary Av', rendererFunction: null, sortable: true },
  { name: 'primary_percent_av', title: '% Available', rendererFunction: null, sortable: true },
  { name: 'primary_tickets_cost', title: 'Primary Total Cost', rendererFunction: null, sortable: false },
  { name: 'cloakedness', title: 'Cloakedness', rendererFunction: null, sortable: false },
  { name: 'secondary_tix_av', title: 'Resale Av', rendererFunction: null, sortable: false },
  { name: 'primary_min_price_face', title: 'Min Face Price', rendererFunction: null, sortable: false },
  { name: 'primary_min_price_total', title: 'Min Total Price', rendererFunction: null, sortable: false },
  { name: 'sh_min_price', title: 'SH Min Price', rendererFunction: null, sortable: false },
  { name: 'sh_tickets_av', title: 'SH Av', rendererFunction: null, sortable: true },
  { name: 'sh_total_sales', title: 'SH Total Sales', rendererFunction: null, sortable: true },
  { name: 'sh_sales_24hr', title: 'SH 24Hr Sales', rendererFunction: null, sortable: false },
  { name: 'sh_sales_3ma', title: 'SH Sales 3 Day MA', rendererFunction: null, sortable: false },
  { name: 'sh_sales_7ma', title: 'SH Sales 7 Day MA', rendererFunction: null, sortable: false },
  { name: 'sh_1_day_min_price_ma', title: 'SH Min Price 1 Day MA', rendererFunction: null, sortable: false },
  { name: 'sh_3_day_min_price_ma', title: 'SH Min Price 3 Day MA', rendererFunction: null, sortable: false },
  { name: 'sh_7_day_min_price_ma', title: 'SH Min Price 7 Day MA', rendererFunction: null, sortable: false },
  { name: 'sh_30_day_min_price_ma', title: 'SH Min Price 30 Day MA', rendererFunction: null, sortable: false },
  { name: 'sh_3ma', title: 'SH 3 Day MA', rendererFunction: null, sortable: false },
  { name: 'sh_7ma', title: 'SH 7 Day MA', rendererFunction: null, sortable: false },
  { name: 'sh_num_viewing', title: 'SH # Viewing', rendererFunction: null, sortable: true },
  { name: 'sb_total_num_purchased', title: 'SB Purchased', rendererFunction: null, sortable: true },
  { name: 'sb_total_num_held', title: 'SB Held', rendererFunction: null, sortable: true },
  { name: 'sb_total_num_sold', title: 'SB Sold', rendererFunction: null, sortable: true },
  { name: 'sb_today_num_sold', title: 'SB Today Num Sold', rendererFunction: null, sortable: true },
  { name: 'sb_seven_day_num_sold', title: 'SB 7 Day Sales', rendererFunction: null, sortable: true },
  { name: 'sb_thirty_day_num_sold', title: 'SB 30 Day Sales', rendererFunction: null, sortable: true },
  { name: 'days_since_last_sale', title: 'Days Since Last Sale', rendererFunction: null, sortable: false },
  { name: 'days_since_last_purchase', title: 'Days Since Last Purchase', rendererFunction: null, sortable: false },
  { name: 'sb_last_invoice_date', title: 'SB Last Inv Date', rendererFunction: null, sortable: true },
  { name: 'sb_one_day_pace', title: 'SB 1 Day Pace', rendererFunction: null, sortable: false },
  { name: 'sb_three_day_pace', title: 'SB 3 Day Pace', rendererFunction: null, sortable: false },
  { name: 'sb_pace', title: 'SB 7 Day Pace', rendererFunction: null, sortable: true },
  { name: 'sb_thirty_day_pace', title: 'SB 30 Day Pace', rendererFunction: null, sortable: false },
  { name: 'sb_total_margin', title: 'SB Total Margin', rendererFunction: null, sortable: false },
  { name: 'sb_today_margin', title: 'SB Today Margin', rendererFunction: null, sortable: false },
  { name: 'sb_seven_day_margin', title: 'SB 7 Day Margin', rendererFunction: null, sortable: false },
  { name: 'sb_thirty_day_margin', title: 'SB 30 Day Margin', rendererFunction: null, sortable: false },
  { name: 'total_cost_of_tickets_held', title: 'Total Cost of Held', rendererFunction: null, sortable: false },
  { name: 'tickets_needed_to_sell_per_hour', title: 'Needed To Sell per Hr', rendererFunction: null, sortable: false },
  { name: 'tickets_needed_to_sell_per_day', title: 'Needed To Sell per Day', rendererFunction: null, sortable: false },
  { name: 'inventory_tags', title: 'Inventory Tags', rendererFunction: null, sortable: false },
  { name: 'event_tags', title: 'Event Tags', rendererFunction: null, sortable: false },
  { name: 'mrclean_links', title: 'MrClean Links', rendererFunction: params => params.value, sortable: false },
];

export const defaultColumnWidths = [
  { columnName: 'event_id', width: 0.04 * windowWidth },
  { columnName: 'emoji', width: 0.04 * windowWidth },
  { columnName: 'event_name', width: 0.1 * windowWidth },
  { columnName: 'inventory_tags', width: 0.1 * windowWidth },
  { columnName: 'event_links', width: 0.13 * windowWidth },
  { columnName: 'event_date', width: 0.08 * windowWidth },
  { columnName: 'performer', width: 0.08 * windowWidth },
  { columnName: 'day_of_week', width: 0.08 * windowWidth },
  { columnName: 'event_genre', width: 0.08 * windowWidth },
  { columnName: 'onsale_date', width: 0.05 * windowWidth },
  { columnName: 'checked_time', width: 0.05 * windowWidth },
  { columnName: 'days_until_event', width: 0.05 * windowWidth },
  { columnName: 'days_since_last_checked', width: 0.05 * windowWidth },
  { columnName: 'venue_name', width: 0.08 * windowWidth },
  { columnName: 'venue_city', width: 0.05 * windowWidth },
  { columnName: 'primary_qnt_3day', width: 0.05 * windowWidth },
  { columnName: 'primary_qnt_7day', width: 0.05 * windowWidth },
  { columnName: 'primary_qnt_30day', width: 0.05 * windowWidth },
  { columnName: 'primary_percent_av', width: 0.05 * windowWidth },
  { columnName: 'primary_tix_av', width: 0.05 * windowWidth },
  { columnName: 'secondary_tix_av', width: 0.05 * windowWidth },
  { columnName: 'primary_min_price_total', width: 0.05 * windowWidth },
  { columnName: 'primary_min_price_total', width: 0.05 * windowWidth },
  { columnName: 'one_day_primary_pace', width: 0.05 * windowWidth },
  { columnName: 'three_day_primary_pace', width: 0.05 * windowWidth },
  { columnName: 'seven_day_primary_pace', width: 0.05 * windowWidth },
  { columnName: 'thirty_day_primary_pace', width: 0.05 * windowWidth },
  { columnName: 'primary_tickets_cost', width: 0.03 * windowWidth },
  { columnName: 'cloakedness', width: 0.03 * windowWidth },
  { columnName: 'sh_tickets_av', width: 0.05 * windowWidth },
  { columnName: 'sh_total_sales', width: 0.05 * windowWidth },
  { columnName: 'sh_3ma', width: 0.05 * windowWidth },
  { columnName: 'sh_7ma', width: 0.05 * windowWidth },
  { columnName: 'sh_sales_3ma', width: 0.05 * windowWidth },
  { columnName: 'sh_sales_7ma', width: 0.05 * windowWidth },
  { columnName: 'sh_sales_24hr', width: 0.05 * windowWidth },
  { columnName: 'sh_1_day_min_price_ma', width: 0.05 * windowWidth },
  { columnName: 'sh_3_day_min_price_ma', width: 0.05 * windowWidth },
  { columnName: 'sh_7_day_min_price_ma', width: 0.05 * windowWidth },
  { columnName: 'sh_30_day_min_price_ma', width: 0.05 * windowWidth },
  { columnName: 'sh_num_viewing', width: 0.05 * windowWidth },
  { columnName: 'sh_min_price', width: 0.05 * windowWidth },
  { columnName: 'sb_total_num_purchased', width: 0.05 * windowWidth },
  { columnName: 'sb_total_num_held', width: 0.05 * windowWidth },
  { columnName: 'sb_total_num_sold', width: 0.05 * windowWidth },
  { columnName: 'sb_seven_day_num_sold', width: 0.05 * windowWidth },
  { columnName: 'sb_thirty_day_num_sold', width: 0.05 * windowWidth },
  { columnName: 'sb_last_invoice_date', width: 0.05 * windowWidth },
  { columnName: 'days_since_last_sale', width: 0.05 * windowWidth },
  { columnName: 'days_since_last_purchase', width: 0.05 * windowWidth },
  { columnName: 'sb_pace', width: 0.05 * windowWidth },
  { columnName: 'sb_one_day_pace', width: 0.05 * windowWidth },
  { columnName: 'sb_three_day_pace', width: 0.05 * windowWidth },
  { columnName: 'sb_thirty_day_pace', width: 0.05 * windowWidth },
  { columnName: 'sb_total_margin', width: 0.05 * windowWidth },
  { columnName: 'sb_thirty_day_margin', width: 0.05 * windowWidth },
  { columnName: 'sb_seven_day_margin', width: 0.05 * windowWidth },
  { columnName: 'sb_today_margin', width: 0.05 * windowWidth },
  { columnName: 'sb_today_num_sold', width: 0.05 * windowWidth },
  { columnName: 'total_cost_of_tickets_held', width: 0.05 * windowWidth },
  { columnName: 'tickets_needed_to_sell_per_hour', width: 0.05 * windowWidth },
  { columnName: 'tickets_needed_to_sell_per_day', width: 0.05 * windowWidth },
  { columnName: 'primary_event_capacity', width: 0.05 * windowWidth },
  { columnName: 'venue_state', width: 0.05 * windowWidth },
  { columnName: 'venue_type', width: 0.03 * windowWidth },
  { columnName: 'event_tags', width: 0.05 * windowWidth },
  { columnName: 'mrclean_links', width: 0.03 * windowWidth },
];

export const columnWidths = [
  { columnName: 'event_id', width: 0.04 * windowWidth },
  { columnName: 'emoji', width: 0.04 * windowWidth },
  { columnName: 'event_name', width: 0.1 * windowWidth },
  { columnName: 'event_links', width: 0.13 * windowWidth },
  { columnName: 'event_date', width: 0.03 * windowWidth },
  { columnName: 'day_of_week', width: 0.03 * windowWidth },
  { columnName: 'event_genre', width: 0.03 * windowWidth },
  { columnName: 'performer', width: 0.08 * windowWidth },
  { columnName: 'onsale_date', width: 0.03 * windowWidth },
  { columnName: 'checked_time', width: 0.03 * windowWidth },
  { columnName: 'venue_name', width: 0.03 * windowWidth },
  { columnName: 'venue_city', width: 0.03 * windowWidth },
  { columnName: 'venue_capacity', width: 0.03 * windowWidth },
  { columnName: 'event_id', width: 0.01 * windowWidth },
  { columnName: 'event_name', width: 0.05 * windowWidth },
  { columnName: 'inventory_tags', width: 0.1 * windowWidth },
  { columnName: 'event_links', width: 0.06 * windowWidth },
  { columnName: 'event_date', width: 0.04 * windowWidth },
  { columnName: 'onsale_date', width: 0.04 * windowWidth },
  { columnName: 'days_until_event', width: 0.05 * windowWidth },
  { columnName: 'days_since_last_checked', width: 0.05 * windowWidth },
  { columnName: 'venue_name', width: 0.03 * windowWidth },
  { columnName: 'venue_city', width: 0.02 * windowWidth },
  { columnName: 'primary_qnt_3day', width: 0.03 * windowWidth },
  { columnName: 'primary_qnt_7day', width: 0.03 * windowWidth },
  { columnName: 'primary_qnt_30day', width: 0.03 * windowWidth },
  { columnName: 'primary_percent_av', width: 0.03 * windowWidth },
  { columnName: 'primary_tix_av', width: 0.03 * windowWidth },
  { columnName: 'secondary_tix_av', width: 0.03 * windowWidth },
  { columnName: 'one_day_primary_pace', width: 0.05 * windowWidth },
  { columnName: 'three_day_primary_pace', width: 0.05 * windowWidth },
  { columnName: 'seven_day_primary_pace', width: 0.05 * windowWidth },
  { columnName: 'thirty_day_primary_pace', width: 0.05 * windowWidth },
  { columnName: 'primary_min_price_face', width: 0.03 * windowWidth },
  { columnName: 'primary_min_price_total', width: 0.03 * windowWidth },
  { columnName: 'primary_tickets_cost', width: 0.03 * windowWidth },
  { columnName: 'cloakedness', width: 0.03 * windowWidth },
  { columnName: 'sh_tickets_av', width: 0.03 * windowWidth },
  { columnName: 'sh_total_sales', width: 0.03 * windowWidth },
  { columnName: 'sh_3ma', width: 0.03 * windowWidth },
  { columnName: 'sh_7ma', width: 0.03 * windowWidth },
  { columnName: 'sh_1_day_min_price_ma', width: 0.05 * windowWidth },
  { columnName: 'sh_3_day_min_price_ma', width: 0.05 * windowWidth },
  { columnName: 'sh_7_day_min_price_ma', width: 0.05 * windowWidth },
  { columnName: 'sh_30_day_min_price_ma', width: 0.05 * windowWidth },
  { columnName: 'sh_sales_3ma', width: 0.03 * windowWidth },
  { columnName: 'sh_sales_7ma', width: 0.03 * windowWidth },
  { columnName: 'sh_sales_24hr', width: 0.03 * windowWidth },
  { columnName: 'sh_num_viewing', width: 0.03 * windowWidth },
  { columnName: 'sh_min_price', width: 0.03 * windowWidth },
  { columnName: 'sb_total_num_purchased', width: 0.03 * windowWidth },
  { columnName: 'sb_total_num_held', width: 0.03 * windowWidth },
  { columnName: 'sb_total_num_sold', width: 0.03 * windowWidth },
  { columnName: 'sb_seven_day_num_sold', width: 0.03 * windowWidth },
  { columnName: 'sb_thirty_day_num_sold', width: 0.03 * windowWidth },
  { columnName: 'sb_last_invoice_date', width: 0.03 * windowWidth },
  { columnName: 'days_since_last_sale', width: 0.05 * windowWidth },
  { columnName: 'days_since_last_purchase', width: 0.05 * windowWidth },
  { columnName: 'sb_pace', width: 0.03 * windowWidth },
  { columnName: 'sb_one_day_pace', width: 0.03 * windowWidth },
  { columnName: 'sb_three_day_pace', width: 0.03 * windowWidth },
  { columnName: 'sb_thirty_day_pace', width: 0.03 * windowWidth },
  { columnName: 'sb_total_margin', width: 0.03 * windowWidth },
  { columnName: 'sb_thirty_day_margin', width: 0.03 * windowWidth },
  { columnName: 'sb_seven_day_margin', width: 0.03 * windowWidth },
  { columnName: 'sb_today_margin', width: 0.03 * windowWidth },
  { columnName: 'sb_today_num_sold', width: 0.03 * windowWidth },
  { columnName: 'total_cost_of_tickets_held', width: 0.03 * windowWidth },
  { columnName: 'tickets_needed_to_sell_per_hour', width: 0.03 * windowWidth },
  { columnName: 'tickets_needed_to_sell_per_day', width: 0.03 * windowWidth },
  { columnName: 'primary_event_capacity', width: 0.03 * windowWidth },
  { columnName: 'venue_state', width: 0.03 * windowWidth },
  { columnName: 'venue_type', width: 0.03 * windowWidth },
  { columnName: 'event_tags', width: 0.05 * windowWidth },
  { columnName: 'mrclean_links', width: 0.03 * windowWidth },
];

export const tableColumnExtensions = [
  { columnName: 'event_id', wordWrapEnabled: true },
  { columnName: 'emoji', wordWrapEnabled: true },
  { columnName: 'event_name', wordWrapEnabled: true },
  { columnName: 'inventory_tags', wordWrapEnabled: true },
  { columnName: 'event_genre', wordWrapEnabled: true },
  { columnName: 'performer', wordWrapEnabled: true },
  { columnName: 'event_links', wordWrapEnabled: true },
  { columnName: 'event_date', wordWrapEnabled: true },
  { columnName: 'day_of_week', wordWrapEnabled: true },
  { columnName: 'days_until_event', wordWrapEnabled: true },
  { columnName: 'onsale_date', wordWrapEnabled: true },
  { columnName: 'checked_time', wordWrapEnabled: true },
  { columnName: 'days_since_last_checked', wordWrapEnabled: true },
  { columnName: 'venue_name', wordWrapEnabled: true },
  { columnName: 'venue_city', wordWrapEnabled: true },
  { columnName: 'venue_capacity', wordWrapEnabled: true },
  { columnName: 'venue_type', wordWrapEnabled: true },
  { columnName: 'primary_qnt_3day', wordWrapEnabled: true },
  { columnName: 'primary_qnt_7day', wordWrapEnabled: true },
  { columnName: 'primary_qnt_30day', wordWrapEnabled: true },
  { columnName: 'primary_percent_av', wordWrapEnabled: true },
  { columnName: 'primary_tix_av', wordWrapEnabled: true },
  { columnName: 'secondary_tix_av', wordWrapEnabled: true },
  { columnName: 'primary_min_price_face', wordWrapEnabled: true },
  { columnName: 'primary_min_price_total', wordWrapEnabled: true },
  { columnName: 'primary_tickets_cost', wordWrapEnabled: true },
  { columnName: 'cloakedness', wordWrapEnabled: true },
  { columnName: 'one_day_primary_pace', wordWrapEnabled: true },
  { columnName: 'three_day_primary_pace', wordWrapEnabled: true },
  { columnName: 'seven_day_primary_pace', wordWrapEnabled: true },
  { columnName: 'thirty_day_primary_pace', wordWrapEnabled: true },
  { columnName: 'sh_tickets_av', wordWrapEnabled: true },
  { columnName: 'sh_total_sales', wordWrapEnabled: true },
  { columnName: 'sh_3ma', wordWrapEnabled: true },
  { columnName: 'sh_7ma', wordWrapEnabled: true },
  { columnName: 'sh_1_day_min_price_ma', wordWrapEnabled: true },
  { columnName: 'sh_3_day_min_price_ma', wordWrapEnabled: true },
  { columnName: 'sh_7_day_min_price_ma', wordWrapEnabled: true },
  { columnName: 'sh_30_day_min_price_ma', wordWrapEnabled: true },
  { columnName: 'sh_sales_3ma', wordWrapEnabled: true },
  { columnName: 'sh_sales_7ma', wordWrapEnabled: true },
  { columnName: 'sh_sales_24hr', wordWrapEnabled: true },
  { columnName: 'sh_min_price', wordWrapEnabled: true },
  { columnName: 'sh_num_viewing', wordWrapEnabled: true },
  { columnName: 'sb_total_num_purchased', wordWrapEnabled: true },
  { columnName: 'sb_total_num_held', wordWrapEnabled: true },
  { columnName: 'sb_total_num_sold', wordWrapEnabled: true },
  { columnName: 'sb_seven_day_num_sold', wordWrapEnabled: true },
  { columnName: 'sb_thirty_day_num_sold', wordWrapEnabled: true },
  { columnName: 'sb_last_invoice_date', wordWrapEnabled: true },
  { columnName: 'days_since_last_sale', wordWrapEnabled: true },
  { columnName: 'days_since_last_purchase', wordWrapEnabled: true },
  { columnName: 'sb_pace', wordWrapEnabled: true },
  { columnName: 'sb_one_day_pace', wordWrapEnabled: true },
  { columnName: 'sb_three_day_pace', wordWrapEnabled: true },
  { columnName: 'sb_thirty_day_pace', wordWrapEnabled: true },
  { columnName: 'sb_today_num_sold', wordWrapEnabled: true },
  { columnName: 'primary_event_capacity', wordWrapEnabled: true },
  { columnName: 'sb_total_margin', wordWrapEnabled: true },
  { columnName: 'sb_thirty_day_margin', wordWrapEnabled: true },
  { columnName: 'sb_seven_day_margin', wordWrapEnabled: true },
  { columnName: 'sb_today_margin', wordWrapEnabled: true },
  { columnName: 'total_cost_of_tickets_held', wordWrapEnabled: true },
  { columnName: 'tickets_needed_to_sell_per_hour', wordWrapEnabled: true },
  { columnName: 'tickets_needed_to_sell_per_day', wordWrapEnabled: true },
  { columnName: 'venue_state', wordWrapEnabled: true },
  { columnName: 'event_tags', wordWrapEnabled: true },
  { columnName: 'mrclean_links', wordWrapEnabled: true },
];

export const sortingStateColumnExtensions = [
  { columnName: 'event_id', sortingEnabled: false },
  { columnName: 'event_links', sortingEnabled: false },
  { columnName: 'venue_state', sortingEnabled: false },
  { columnName: 'mrclean_links', sortingEnabled: false },
];
